module.exports = __webpack_public_path__ + "img/savings.31454a75.svg";